import { render, staticRenderFns } from "./LoggerComponent.vue?vue&type=template&id=bfa5fcb8&scoped=true&"
import script from "./LoggerComponent.vue?vue&type=script&lang=js&"
export * from "./LoggerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa5fcb8",
  null
  
)

export default component.exports